import {
  Menubar,
  MenubarContent,
  MenubarItem,
  MenubarMenu,
  MenubarSeparator,
  MenubarSub,
  MenubarSubContent,
  MenubarSubTrigger,
  MenubarTrigger,
} from "@/shadcn/components/ui/menubar";
import { DropDownMenuItem } from "@/types";
import React from "react";

// Trigger - ReactNode that will be the trigger for the dropdown menu
// Items - Array of DropDownMenuItem objects - can be a single item
// or an array of sub items (would expand to its own sub menu)
type DropDownMenuProps = {
  trigger: React.ReactNode;
  items: DropDownMenuItem[];
};

const DropDownMenu: React.FC<DropDownMenuProps> = ({ trigger, items }) => {
  return (
    <Menubar className="bg-card !m-0 w-full !border-none !p-0 !shadow-none !outline-none">
      <MenubarMenu>
        {/* Trigger that expands the Menu */}
        <MenubarTrigger className="!m-0 w-full !border-none !bg-transparent !p-0 !shadow-none !outline-none">
          {trigger}
        </MenubarTrigger>
        <MenubarContent>
          {items.map((item, index) =>
            // SubItems
            item.subItems ? (
              <React.Fragment key={index}>
                {/* If the first item is a sub menu item, do not add a Separator above it */}
                {index !== 0 && <MenubarSeparator />}
                <MenubarSub>
                  <MenubarSubTrigger>{item.label}</MenubarSubTrigger>
                  <MenubarSubContent>
                    {item.subItems.map((subItem, subIndex) => (
                      <MenubarItem key={subIndex} onClick={subItem.onClick}>
                        {subItem.label}
                      </MenubarItem>
                    ))}
                  </MenubarSubContent>
                </MenubarSub>
              </React.Fragment>
            ) : (
              // Regular Items - No Sub Items
              <MenubarItem key={index} onClick={item.onClick}>
                {item.label}
              </MenubarItem>
            )
          )}
        </MenubarContent>
      </MenubarMenu>
    </Menubar>
  );
};

export default DropDownMenu;
